import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { TextField } from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers'

interface InvoiceAmortisationCancelParamsProps {
  Cancel: string
}

export const InvoiceAmortisationCancelDialog = (props: any) => {
  const {
    ID,
    openCancelDialog,
    setOpenCancelDialog,
    title,
    menu,
    handleCancel,
    passID,
  } = props

  const ParamsSchema = yup.object().shape({
    Cancel: yup.string().required('Reason is required'),
  })

  const { handleSubmit, register, errors, control, watch, setValue } = useForm<
    InvoiceAmortisationCancelParamsProps
  >({
    defaultValues: {},
    mode: 'all',
    resolver: yupResolver(ParamsSchema),
  })

  return (
    <CommonDialog
      fullWidth
      open={openCancelDialog}
      onClose={() => setOpenCancelDialog(false)}
      sections={{
        header: {
          title: 'Cancellation',
          infoLine: menu?.DocNo,
          rightInfoLine: amtStr(menu?.Amount),
        },
        body: () => (
          <>
            <div className="content-wrap full">
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 500,
                }}
              >
                {`Are you sure you want to `}
              </span>
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 700,
                }}
              >
                {`${title}`}
              </span>
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 500,
                }}
              >
                {'?'}
              </span>
            </div>
            <Controller
              as={TextField}
              id="standard-basic"
              required
              name="Cancel"
              label="Cancellation Reason"
              autoComplete="off"
              control={control}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.Cancel?.message}
              error={errors?.Cancel ? true : false}
            />
          </>
        ),
        footer: {
          actions: [
            {
              displayText: 'No',
              props: {
                onClick: () => setOpenCancelDialog(false),
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Yes',
              props: {
                onClick: handleSubmit(data => {
                  if (passID) {
                    handleCancel(ID ?? menu?.RefundID, data.Cancel)
                  } else {
                    handleCancel({ variables: ID })
                  }
                  setOpenCancelDialog(false)
                }),
                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  )
}
